import TermsAndConditionsService from '@treasury/domain/channel/services/account/terms-and-conditions-service';
import DownloadService from '@treasury/domain/channel/services/download/download-service.js';
import {
    AuditCode,
    ResourceType,
    UserActivityService,
} from '@treasury/domain/channel/services/user-activity';
import { FiDate } from '@treasury/domain/dates';

export default class TermsAndConditionsClient {
    public getTermsAndConditions() {
        return TermsAndConditionsService.getTermsAndConditions();
    }

    public checkTermsAndConditions() {
        return TermsAndConditionsService.checkTermsAndConditions();
    }

    public acceptTermsAndConditions() {
        return TermsAndConditionsService.acceptTermsAndConditions();
    }

    public declineTermsAndConditions() {
        return UserActivityService.userInteractionAudit(
            ResourceType.AccountResources,
            AuditCode.DeclineTermsAndConditions
        );
    }

    public downloadTermsAndConditions(outputType: string) {
        const fileSuffix = new FiDate(new Date()).toIsoDate();
        return DownloadService.download(
            fileSuffix,
            outputType,
            'TermsAndConditions',
            { page: 'TermsAndConditions' },
            []
        );
    }
}
